export function attachSavedIdsToPayload(payload: any, applicantsSavedIds: any) {
  // Add vehicle detail ID if exists
  if (applicantsSavedIds?.vehicleDetailID) {
    payload.vehicleDetail = {
      ...(payload.vehicleDetail || {}),
      id: applicantsSavedIds.vehicleDetailID,
    };
  }

  // Add loan application ID if exists
  if (applicantsSavedIds?.loanApplicationID) {
    payload.loanApplication = {
      ...(payload.loanApplication || {}),
      id: applicantsSavedIds.loanApplicationID,
    };
  }

  // Process each applicant
  if (Array.isArray(payload.applicant)) {
    payload.applicant = payload.applicant.map(
      (applicant: any, index: number) => {
        // Clean sensitive fields
        delete applicant.email;
        delete applicant.phoneNumber;

        // Pick correct income IDs
        const incomeIds =
          index === 0
            ? applicantsSavedIds?.incomeIDs || []
            : applicantsSavedIds?.secondIncomeIDs || [];

        // Map incomes with ids
        const updatedIncomes = (applicant?.income || []).map(
          (income: any, i: number) => ({
            ...income,
            ...(incomeIds[i] ? { id: incomeIds[i] } : {}),
          })
        );

        return {
          ...applicant,
          id:
            index === 0
              ? applicantsSavedIds.applicantID
              : applicantsSavedIds.secondApplicantID,
          employment: {
            ...(applicant.employment || {}),
            id:
              index === 0
                ? applicantsSavedIds.employmentID
                : applicantsSavedIds.secondEmploymentID,
          },
          liabilities: {
            ...(applicant.liabilities || {}),
            id:
              index === 0
                ? applicantsSavedIds.liabilitieID
                : applicantsSavedIds.secondliabilitieID,
          },
          income: updatedIncomes,
        };
      }
    );
  }

  return payload;
}
